import { useMutation } from '@apollo/client/react';
import { useCallback, useState } from 'react';

import { useUserProfile } from '~/contexts/user-profile';
import { ReportSickLeaveDocument, ReportSickLeaveErrorCode, ReportSickLeaveMutationInput } from '~/types';
import { range } from '~/utils/array';

export function useReportSickLeave() {
    const { employment } = useUserProfile();
    const { sickLeaveMinDays = 0, sickLeaveMaxDays = 0 } = employment?.company ?? {};
    const sickLeaveDays = range(sickLeaveMinDays, sickLeaveMaxDays);

    const [reportSickLeaveMutation] = useMutation(ReportSickLeaveDocument);
    const [reportError, setReportError] = useState<ReportSickLeaveErrorCode | null>(null);

    const clearReportError = useCallback(() => {
        setReportError(null);
    }, []);

    const reportSickLeave = useCallback(
        async (input: ReportSickLeaveMutationInput) => {
            setReportError(null);
            const result = await reportSickLeaveMutation({ variables: { input } });
            const errorCode = result.data?.reportSickLeave?.error;
            if (errorCode) {
                setReportError(errorCode);
            }
            return result;
        },
        [reportSickLeaveMutation]
    );

    return {
        sickLeaveDays,
        reportSickLeave,
        reportError,
        clearReportError
    };
}
